import React, { useState } from 'react';
import { useInView } from 'react-intersection-observer';
import NewsCategories from './news/NewsCategories';
import NewsCard from './news/NewsCard';
import { newsItems } from './news/newsData';
import Section from './Section';
import { NewsCategoryId } from './news/constants';

interface NewsProps {
  standalone?: boolean;
}

const News: React.FC<NewsProps> = ({ standalone = false }) => {
  const [selectedCategory, setSelectedCategory] = useState<NewsCategoryId>('all');
  const { ref, inView } = useInView({
    triggerOnce: true,
    threshold: 0.1,
  });

  const filteredNews = selectedCategory === 'all'
    ? newsItems
    : newsItems.filter(item => item.category === selectedCategory);

  if (standalone) {
    return (
      <Section id="news" className="min-h-screen py-32 bg-[#F5F3EF]">
        <div className="mx-auto max-w-6xl px-5 lg:px-6">
          <div ref={ref} className={`transition-all duration-1000 ${inView ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-10'}`}>
            <div className="text-center mb-14">
              <div className="inline-flex items-center gap-2 rounded-full border border-[#B8860B]/30 bg-[#B8860B]/10 px-4 py-1.5 mb-6">
                <span className="text-sm font-semibold text-[#B8860B]">最新情報</span>
              </div>
              <h2 className="text-3xl font-bold lg:text-4xl leading-tight text-[#2D3748]">
                ニュース＆トピックス
              </h2>
            </div>
            <NewsCategories
              selectedCategory={selectedCategory}
              onCategoryChange={(category: NewsCategoryId) => setSelectedCategory(category)}
            />
            <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6">
              {filteredNews.map((item) => (
                <NewsCard key={item.id} item={item} />
              ))}
            </div>
          </div>
        </div>
      </Section>
    );
  }

  return (
    <Section id="news" className="bg-white">
      {/* フルワイド画像 */}
      <div className="relative h-[180px] sm:h-[260px] lg:h-[340px] overflow-hidden">
        <img
          src="/images/news.webp"
          alt=""
          className="w-full h-full object-cover"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-transparent via-transparent to-white" />
      </div>

      <div className="mx-auto max-w-6xl px-5 lg:px-6 pb-20 pt-8 lg:pb-28 lg:pt-12">
        <div ref={ref} className={`transition-all duration-1000 ${inView ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-10'}`}>
          <div className="text-center mb-14">
            <div className="inline-flex items-center gap-2 rounded-full border border-[#B8860B]/30 bg-[#B8860B]/10 px-4 py-1.5 mb-6">
              <span className="text-sm font-semibold text-[#B8860B]">最新情報</span>
            </div>
            <h2 className="text-3xl font-bold lg:text-4xl leading-tight text-[#2D3748]">
              ニュース＆トピックス
            </h2>
          </div>

          <NewsCategories
            selectedCategory={selectedCategory}
            onCategoryChange={(category: NewsCategoryId) => setSelectedCategory(category)}
          />

          <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6">
            {filteredNews.map((item) => (
              <NewsCard key={item.id} item={item} />
            ))}
          </div>
        </div>
      </div>
    </Section>
  );
};

export default News;
